import React from "react";
import { useTranslation } from "react-i18next";
import { useSnapshot } from "valtio";
import { useSelector } from "react-redux";

import { getUuidUser } from "@helpers/getUuidUser";

import { store as fidelity } from "../../../../../components/VerticalLayout/store";
import { useFetchGlobal } from "../../../../../api/hooks";
import { RootState } from "../../../../../redux/store";

import { ConfirmationArchive } from "../../ConfirmationArchive";

import { CustomIconsProps } from "./types";
import { useArchiveIds } from "./useArchiveIds";
import { useActivateFidelity } from "./useActivateFidelity";

import ConsultIconButton from "./icons/ConsultIconButton";
import SettingsIconButton from "./icons/SettingsIconButton";
import ArchiveIconButton from "./icons/ArchiveIconButton";
import UnarchiveIconButton from "./icons/UnarchiveIconButton";

export function CustomIconsWrapper({
    e,
    setDataIsUpdated,
    setSelectedRows,
    isFidelityArchived,
    selectedRows,
    setIsConsult,
    setIsAddFidelityClicked,
    setFidelity,
}: CustomIconsProps) {
    const { t } = useTranslation();
    const { fetchGlobal } = useFetchGlobal();
    const fidelityData = useSelector((s: RootState) => s.fidelity.fidelityData);
    const shopsFidelityData = useSelector(
        (s: RootState) => s.fidelity.shopsFidelityData
    );
    const modify = useSelector((s: RootState) => s.fidelity.modify);
    const isSupportCodeValid = useSelector(
        (s: RootState) => s.fidelity.isSupportCodeValid
    );
    const selectedShopId = useSelector(
        (s: RootState) => s.fidelity.selectedShopId
    );
    const isLoading = useSelector((s: RootState) => s.fidelity.isLoading);
    const { franchiseID, oneShop, userID, operatorID } = useSnapshot(fidelity);
    const uuidUser = getUuidUser();

    const [isArchiveModalOpened, setIsArchiveModalOpened] = React.useState(
        false
    );

    const row = e.selectedRow;
    const isLeafRow = row?.subRows === undefined;
    const dataArchive = useArchiveIds(oneShop, fidelityData);

    const activateFidelity = useActivateFidelity({
        row,
        userID,
        franchiseID,
        operatorID,
        uuidUser,
        fetchGlobal,
        setDataIsUpdated,
        t,
    });

    const showConsultOnly = modify === false || isFidelityArchived;
    const showConfirmArchive =
        (isArchiveModalOpened || isSupportCodeValid) &&
        selectedShopId === row.shopId;

    return (
        <React.Fragment>
            {isLeafRow ? (
                <div className="d-flex justify-content-around">
                    {showConsultOnly ? (
                        <ConsultIconButton
                            row={row}
                            setFidelity={setFidelity}
                            setIsAddFidelityClicked={setIsAddFidelityClicked}
                            setIsConsult={setIsConsult}
                            t={t}
                        />
                    ) : null}
                    {modify === true ? (
                        <>
                            <SettingsIconButton
                                row={row}
                                isFidelityArchived={isFidelityArchived}
                                isLoading={isLoading}
                                setSelectedRows={setSelectedRows}
                                t={t}
                            />
                            {!isFidelityArchived ? (
                                <ArchiveIconButton row={row} t={t} />
                            ) : (
                                <UnarchiveIconButton
                                    row={row}
                                    shopsFidelityData={shopsFidelityData}
                                    dataArchive={dataArchive}
                                    isLoading={isLoading}
                                    activateFidelity={activateFidelity}
                                    t={t}
                                />
                            )}
                        </>
                    ) : null}
                </div>
            ) : null}
            {showConfirmArchive ? (
                <ConfirmationArchive
                    isModalOpened={isArchiveModalOpened || isSupportCodeValid}
                    setIsModalOpened={setIsArchiveModalOpened}
                    e={e}
                    setDataIsUpdated={setDataIsUpdated}
                    selectedRows={selectedRows}
                />
            ) : null}
        </React.Fragment>
    );
}
